import { first, flow, values } from 'lodash';

const getFirstValue = flow(
  values,
  first,
);

export default getFirstValue;
